import axios from 'axios';

export const getAllAccommodations= async () => {
    const url = `/api/v1/user_profile/accommodations`;
    const res = await axios.get(url);
    return res.data;
};